import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Table } from 'reactstrap'
import { v1 as uuidv1 } from 'uuid'
import { useTranslation } from 'react-i18next'

import TablePagination from '../../../components/TablePagination'

const TranslationsUpdatesDiffTable = ({
  diff,
  locales = null,
  moveToPage,
  paginationCurrentPage = 1,
  paginationTotalPages = 1,
  userRole = null
}) => {
  const { t } = useTranslation('ProjectsPage')

  return (
    <>
      <Table borderless>
        <thead>
          <tr>
            <th className="w-50">{t('ProjectExports.TranslationsUpdatesDiffTable.columns.before')}</th>
            <th className="w-50">{t('ProjectExports.TranslationsUpdatesDiffTable.columns.after')}</th>
          </tr>
        </thead>
        {diff.map((item) => {
          const localeObject = (locales || []).find(
            (locale) => locale.value === item.locale
          )

          return (
            <tbody key={item.id || uuidv1()}>
              <tr>
                <td className="text-muted" colSpan="2">
                  <div className="d-flex flex-column">
                    <div className="d-flex flex-row">
                      {item.key}
                      {localeObject && (
                        <>
                          &nbsp;(
                          {localeObject.label}
                          )
                        </>
                      )}
                    </div>
                    {userRole === 'admin' && (
                      <div className="d-flex flex-row">
                        <small>
                          {item.path}
                        </small>
                      </div>
                    )}
                  </div>
                </td>
              </tr>
              <tr>
                <td className="text-muted" style={{ backgroundColor: 'rgb(250, 197, 205)' }}>
                  {item.old_value
                    ? item.old_value
                    : (<i>{t('ProjectExports.TranslationsUpdatesDiffTable.emptyValue')}</i>)}
                </td>
                <td style={{ backgroundColor: 'rgb(199, 240, 210)' }}>
                  {item.value || t('ProjectExports.TranslationsUpdatesDiffTable.emptyValue')}
                </td>
              </tr>
            </tbody>
          )
        })}
      </Table>

      <div className="d-flex flex-row justify-content-center">
        <TablePagination
          currentPage={paginationCurrentPage}
          onPaginationClick={(page) => moveToPage(page)}
          totalPages={paginationTotalPages}
        />
      </div>
    </>
  )
}

TranslationsUpdatesDiffTable.propTypes = {
  diff: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    locale: PropTypes.string.isRequired,
    old_value: PropTypes.string,
    path: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })).isRequired,
  locales: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })),
  moveToPage: PropTypes.func.isRequired,
  paginationCurrentPage: PropTypes.number,
  paginationTotalPages: PropTypes.number,
  userRole: PropTypes.string
}

const mapStateToProps = ({
  authentication: {
    role: userRole
  },
  locales: {
    items: locales
  }
}) => ({
  locales,
  userRole
})

export default connect(mapStateToProps)(TranslationsUpdatesDiffTable)
